/* Built In Imports */
import React from 'react';
/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@moms/Ui/LazyLoadImageComponent';
/* Styles */
import DecadeSt from '@moms/styleData/DecadeSt';
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */

const UpperLayout = ({ region, lang, sectionContent }) => {
  const subtext = sectionContent[0]?.additionalTextLine;

  // Extracting required data dynamically
  const titleData = sectionContent.find(
    item => item._modelApiKey === 'section_title'
  );
  const structuredTexts = sectionContent.filter(
    item => item._modelApiKey === 'structured_text'
  );

  return (
    <Flex
      maxW={{ base: '100%', md: '1328px' }}
      px={{ base: '1rem', md: '1rem', lg: '0' }}
      mx={{ md: 'auto' }}
      gap={{ base: '2rem', md: '4rem' }}
      flexDirection={{ base: 'column', md: 'row' }}
      justifyContent={{ md: 'center' }}
    >
      {/* Left box */}
      <Flex
        fontWeight={500}
        textAlign={{ base: 'left', md: 'right' }}
        flexDir={'column'}
      >        
        <Text {...DecadeSt?.[lang]?.text3}>{titleData?.titleText} <Text as="span" fontStyle={'italic'}>{subtext}</Text></Text>
      </Flex>
    </Flex>
  );
};

const LowerLayout = ({ region, lang, sectionContent }) => {
  // Extracting benefits section
  const benefitsSection = sectionContent.find(
    item => item._modelApiKey === 'card_info3_column_group'
  );
  const rearrangedBenefits = benefitsSection?.cards || [];

  return (
    <Flex
      wrap="wrap"
      mx={'auto'}
      flexDirection={{ base: 'column', md: 'row' }}
      maxW="1150px"
      mt={{ md: '2.5rem' }}
      justifyContent={{
        base: 'space-between',
        md: 'center',
        lg: 'space-between',
      }}
    >
      {rearrangedBenefits.map((item, index) => (
        <Box
          px={{ base: '1rem', md: '2rem' }}
          py={{base:'0rem', md:'2rem'}}
          key={index}
          w={{ base: '100%', md: '30%', lg: '10%' }}
          maxW={{ base: '100%', md: 'calc(174px + 4rem)' }}
          textAlign={'left'}
          display={'flex'}
          mt={{ base: '2rem', md: '0' }}
          flexWrap={{ base: 'wrap', md: 'nowrap' }}
          alignItems={{ base: 'flex-start' }}
          justifyContent={{ base: 'center', md: 'flex-start' }}
          flexDir={{ base: 'column', md: 'column' }}
          gap={{ base: '1rem', md: '1.5rem' }}
          borderTop={{
            md: 'none',
            base:
              index === 0
                ? '1px solid transparent'
                : '1px solid rgba(255, 255, 255, 0.20)',
          }}
          borderRight={{ base: 'none', md: rearrangedBenefits.length - 1 == index ? '0' : '1px solid #FFFFFF33'}}
          _last={{ borderBottom: 'none' }}
          flex={{ base: 1, md: '30%', lg: 1 }}
        >
          {/* Icon box */}
          <Box flex={1}>
            <LazyLoadImageComponent
              w="130px"
              h="130px"
              objectFit="cover"
              src={item.thumbnail?.url}
              alt={item.thumbnail?.alt || 'Benefit image'}
            />
            <Text
              mt={{ base: '12px', md: '1.5rem' }}
              maxW={{ lg: '165px' }}
              px={{ base: '0', md: '0' }}
              {...DecadeSt?.[lang]?.item3}
            >
              {item.title}
            </Text>
          </Box>

          {/* Title */}
        </Box>
      ))}
    </Flex>
  );
};

const HowItWorks = ({ region, lang, sectionContent }) => {
  return (
    <Box
      pt={{ base: '4rem', md: '8rem' }}
      pb={{ base: '4rem', md: '6rem' }}
      pos="relative"
      _after={{
        content: "''",
        pos: 'absolute',
        height: '0.6px',
        left: '0',
        right: '0',
        width: '100%',
        bottom: '0',
        zIndex: '1',
        background:
          'radial-gradient(80.14% 21.43% at 50% 50%, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.00) 100%), #010102',
        backdropFilter: 'blur(calc(var(--sds-size-blur-100) / 2))',
        borderTop: '1px solid rgba(255, 255, 255, 0.20)',
      }}
    >
      {/* upper layout */}
      <UpperLayout
        region={region}
        lang={lang}
        sectionContent={sectionContent}
      />

      {/* Lower layout --Benefits Section */}
      <LowerLayout
        region={region}
        lang={lang}
        sectionContent={sectionContent}
      />
    </Box>
  );
};

export default HowItWorks;
